import React from 'react';

import { Badge } from './styles';

/** Tom semântico do badge. Nunca é a única informação: sempre há texto. */
export type BadgeTone = 'positive' | 'warning' | 'neutral' | 'negative';

interface StatusBadgeProps {
  /** Texto visível (ex.: "Ativo", "Pago", "Esgotado"). */
  label: string;
  tone?: BadgeTone;
  /** Rótulo para leitor de tela, quando o texto sozinho não basta. */
  ariaLabel?: string;
}

/**
 * Badge de status do admin. O estado é sempre indicado por **texto + cor**
 * (nunca só por cor), e o `aria-label` deixa o contexto explícito.
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({
  label,
  tone = 'neutral',
  ariaLabel,
}) => (
  <Badge tone={tone} role="status" aria-label={ariaLabel ?? `Status: ${label}`}>
    {label}
  </Badge>
);

export default StatusBadge;
